import { useMemo, useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import LoanService from '../../../services/LoanService';

export default function useLoanWithIncludes(id) {
  const {
    data: propertyData,
    refetch: refetchProperty,
    isFetching: isPropertyFetching,
  } = useQuery({
    queryKey: ['loanProperty', id],
    queryFn: () => LoanService.getLoanProperty(id),
    enabled: !!id,
  });

  const {
    data: loan,
    refetch: refetchLoan,
    isFetching: isLoanFetching,
  } = useQuery({
    queryKey: ['loan', id],
    queryFn: () => LoanService.getLoan(id),
    enabled: !!id,
  });

  const refetch = useCallback(async () => {
    try {
      await Promise.all([refetchLoan(), refetchProperty()]);
    } catch (error) {
      console.log('Error refetching data:', error);
    }
  }, [refetchLoan, refetchProperty]);

  const loanWithIncludes = useMemo(
    () => ({
      ...loan,
      _property_of_loan: propertyData?.[0] || null,
    }),
    [loan, propertyData]
  );

  const isFetching = isLoanFetching || isPropertyFetching;

  return { loan: loan ? loanWithIncludes : null, refetch, isFetching };
}
